/** `/submissions?tab=drafts` opens the hired equipment Drafts tab; `/forms` redirects there (V2-038). */
export const SUBMISSIONS_DRAFTS_PATH = '/submissions?tab=drafts';

/**
 * V2-049: the Submissions status tab a record belongs on. "Revisions completed" is back in the
 * Pending queue; anything unknown opens on All Statuses.
 */
export function statusTabForFormStatus(status: string | null | undefined): string {
  const value = (status ?? '').trim().toLowerCase();
  if (value === 'revisions completed') return 'pending';
  return ['pending', 'need revisions', 'approved', 'declined'].includes(value) ? value : 'all';
}

/** "View in Submissions" for one record, on the tab matching its status (V2-049). */
export function submissionRecordPath(formId: string, status?: string | null): string {
  const tab = statusTabForFormStatus(status ?? 'pending');
  const statusParam = tab === 'pending' ? '' : `&status=${encodeURIComponent(tab)}`;
  return `/submissions?formId=${encodeURIComponent(formId)}${statusParam}`;
}
